import { render, staticRenderFns } from "./MainRekomAdmin.vue?vue&type=template&id=18b5e226"
import script from "./MainRekomAdmin.vue?vue&type=script&lang=js"
export * from "./MainRekomAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports